import { Link } from "react-router-dom";
import { LinkButton } from "@/components/LinkButton";
import { Wordmark } from "@/components/brand/Wordmark";
import { START_CTA, START_HREF } from "./content";

export function SiteNav() {
  return (
    <header className="sticky top-0 z-20 bg-background-normal shadow-[inset_0_-1px_0_var(--line-normal-neutral)]">
      <nav
        aria-label="주요 메뉴"
        className="mx-auto flex h-16 max-w-layout items-center gap-2 px-5"
      >
        <Link to="/" aria-label="텔뷰 처음으로" className="mr-auto rounded-sm">
          <Wordmark />
        </Link>
        <a
          href="#plans"
          className="hidden min-h-12 items-center rounded-sm px-3 text-body-2 font-semibold text-label-neutral hover:text-label-normal sm:inline-flex"
        >
          요금제
        </a>
        <Link
          to="/console"
          className="inline-flex min-h-12 items-center rounded-sm px-3 text-body-2 font-semibold text-label-neutral hover:text-label-normal"
        >
          로그인
        </Link>
        <LinkButton to={START_HREF} size="medium">
          {START_CTA}
        </LinkButton>
      </nav>
    </header>
  );
}
